<script lang="ts">
  import BottomSheet from './BottomSheet.svelte';
  import type { Roulette, WinRecord } from '../lib/types';

  interface Props {
    open: boolean;
    roulette: Roulette;
    onclear: () => void;
    onclose: () => void;
  }

  let { open, roulette, onclear, onclose }: Props = $props();

  let confirmingClear = $state(false);

  $effect(() => {
    if (!open) confirmingClear = false;
  });

  function setNameOf(setId: string): string {
    const s = roulette.sets.find((x) => x.id === setId);
    return s ? s.name : '?';
  }

  function fmtDate(iso: string): string {
    try {
      const d = new Date(iso);
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const hh = String(d.getHours()).padStart(2, '0');
      const mm = String(d.getMinutes()).padStart(2, '0');
      return `${d.getFullYear()}-${m}-${day} ${hh}:${mm}`;
    } catch {
      return iso;
    }
  }

  const history: WinRecord[] = $derived(roulette.winHistory);
</script>

<BottomSheet {open} title="履歴" {onclose}>
  <p class="meta">「{roulette.name}」の勝利履歴 ({history.length} 件 / 上限 100)</p>

  {#if history.length === 0}
    <div class="empty">履歴はまだありません。</div>
  {:else}
    <ul class="hist-list">
      {#each history as rec, i (i)}
        <li class="row">
          <span class="dt">{fmtDate(rec.spinAt)}</span>
          <span class="text">{rec.text}</span>
          <span class="setname">{setNameOf(rec.setId)}</span>
        </li>
      {/each}
    </ul>

    {#if confirmingClear}
      <div class="confirm">
        <span>すべて削除しますか?</span>
        <button class="cancel" onclick={() => (confirmingClear = false)}>キャンセル</button>
        <button class="danger" onclick={() => { onclear(); confirmingClear = false; }}>
          削除
        </button>
      </div>
    {:else}
      <div class="actions">
        <button class="clear-btn" onclick={() => (confirmingClear = true)}>
          履歴を全削除
        </button>
      </div>
    {/if}
  {/if}
</BottomSheet>

<style>
  .meta {
    margin: 0 0 var(--space-md);
    font-size: var(--font-size-sm);
    color: var(--color-fg-muted);
  }
  .empty {
    padding: var(--space-xl) 0;
    text-align: center;
    color: var(--color-fg-muted);
    font-size: var(--font-size-sm);
  }
  .hist-list {
    list-style: none;
    margin: 0 0 var(--space-md);
    padding: 0;
    max-height: 55vh;
    overflow-y: auto;
    border: 1px solid var(--color-border);
    border-radius: var(--radius-sm);
    background: var(--color-bg);
  }
  .row {
    display: grid;
    grid-template-columns: 110px 1fr auto;
    gap: var(--space-sm);
    align-items: center;
    padding: 8px 12px;
    border-bottom: 1px solid var(--color-border);
    font-size: var(--font-size-sm);
  }
  .row:last-child {
    border-bottom: none;
  }
  .dt {
    font-family: ui-monospace, 'SFMono-Regular', monospace;
    font-size: 11px;
    color: var(--color-fg-muted);
    white-space: nowrap;
  }
  .text {
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .setname {
    font-size: 11px;
    color: var(--color-fg-muted);
    background: var(--color-border);
    padding: 2px 6px;
    border-radius: 100px;
    white-space: nowrap;
  }
  .actions {
    text-align: center;
  }
  .clear-btn {
    padding: 8px 16px;
    border: 1px solid var(--color-border);
    border-radius: var(--radius-sm);
    color: var(--color-fg-muted);
    font-size: var(--font-size-sm);
  }
  .clear-btn:active {
    background: var(--color-border);
  }
  .confirm {
    display: flex;
    align-items: center;
    gap: var(--space-sm);
    padding: var(--space-md);
    background: rgba(233, 69, 96, 0.1);
    border-radius: var(--radius-sm);
  }
  .confirm span {
    flex: 1;
    color: var(--color-accent);
    font-weight: 600;
    font-size: var(--font-size-sm);
  }
  .confirm button {
    padding: 6px 12px;
    border-radius: var(--radius-sm);
    font-weight: 600;
    font-size: var(--font-size-sm);
  }
  .confirm .cancel {
    background: var(--color-border);
    color: var(--color-fg);
  }
  .confirm .danger {
    background: var(--color-accent);
    color: var(--color-accent-fg);
  }
</style>
